import { getLanguage } from 'i18n/i18nUtils';
import { useEffect } from 'react';
import useIsRtl from 'hooks/useIsRtl';

const useSetHtmlLanguageAttributes = () => {
  const isRtl = useIsRtl();

  useEffect(() => {
    const htmlElement = document.getElementsByTagName('html')[0];
    htmlElement.setAttribute('lang', getLanguage());
    htmlElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
  });
};

export default useSetHtmlLanguageAttributes;
